/*
  © 2024 KondaSoft
  https://www.kondasoft.com
*/

class PredictiveSearch extends HTMLElement {
  constructor () {
    super()

    this.form = this.querySelector('form.search-form')
    this.input = this.form.querySelector('input[type="search"]')
    this.results = this.form.querySelector('#predictive-search')
    this.status = this.form.querySelector('#predictive-search-status')
    this.emptyContainer = this.querySelector('.search-empty')
    this.inputFocusTimeout

    this.input.addEventListener('focus', () => {
      this.onInputFocus()
    })

    this.input.addEventListener('blur', () => {
      this.onInputBlur()
    })

    this.input.addEventListener('input', window.theme.debounce(() => {
      this.getSearchResults()
    }, 300).bind(this))

    document.querySelector('#offcanvas-search')?.addEventListener('shown.bs.offcanvas', () => {
      this.input.focus()
    })

    document.querySelector('#offcanvas-menu')?.addEventListener('hidden.bs.offcanvas', () => {
      this.input.value = ''
      this.input.dispatchEvent(new CustomEvent('input'))
    })

    if (this.closest('#navbar-desktop')) {
      window.onClickOutside(this, () => {
        this.input.value = ''
        this.input.dispatchEvent(new CustomEvent('input'))
      })
    }
 
    this.accessibilityEventIsInit = false
  }

  async getSearchResults () {
    const searchTerm = this.input.value.trim()

    if (searchTerm.length) {
      const response = await fetch(`${window.Shopify.routes.predictive_search_url}?q=${searchTerm}&resources[type]=${this.dataset.resourcesType}&resources[limit]=10&section_id=predictive-search`)

      if (response.ok) {
        const data = await response.text()
        const resultsMarkup = new DOMParser().parseFromString(data, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML

        this.results.innerHTML = resultsMarkup

        this.emptyContainer?.setAttribute('hidden', 'hidden')
        this.input.setAttribute('aria-expanded', 'true')
        this.status.textContent = this.querySelector('#predictive-search-results').dataset.resultsText

        this.results.querySelectorAll('.jdgm-prev-badge__stars').forEach(elem => {
          elem.setAttribute('tabindex', '-1')
        })

        this.querySelectorAll('.btn-search-close-results').forEach(btn => {
          btn.addEventListener('click', () => {
            this.input.value = ''
            this.input.dispatchEvent(new CustomEvent('input'))
          })
        })

        this.handleAccessibility()
      } else {
        // TODO: Handle errors
      }
    } else {
      this.emptyContainer?.removeAttribute('hidden')
      this.results.innerHTML = ''
      this.input.setAttribute('aria-expanded', 'false')
      this.input.removeAttribute('aria-activedescendant')
      this.status.textContent = ''
    }
  }

  handleAccessibility () {
    let x = -1

    function listenKeyup (event) {
      const items = this.querySelectorAll('#predictive-search-results a, #predictive-search-results button')

      if (!items.length) return

      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
        items.forEach(elem => {
          elem.closest('[role="option"]').setAttribute('aria-selected', 'false')
        })
      }

      switch (event.code) {
        case 'ArrowUp':
          if (x <= 0) {
            x = items.length
          }
          x--
          items.forEach((elem, index) => {
            if (index === x) {
              elem.focus()
              elem.closest('[role="option"]').setAttribute('aria-selected', 'true')
              this.input.setAttribute('aria-activedescendant', elem.closest('[role="option"]').getAttribute('id'))
            }
          })
          break
        case 'ArrowDown':
          if (x === items.length - 1) {
            x = -1
          }
          x++
          items.forEach((elem, index) => {
            if (index === x) {
              elem.focus()
              elem.closest('[role="option"]').setAttribute('aria-selected', 'true')
              this.input.setAttribute('aria-activedescendant', elem.closest('[role="option"]').getAttribute('id'))
            }
          })
          break
        case 'Enter':
          console.log('Enter')
          break
      }
    }

    if (!this.accessibilityEventIsInit) {
      this.addEventListener('keyup', listenKeyup)
      this.accessibilityEventIsInit = true
    }
  }

  onInputFocus () {
    let i = 0
    this.input.placeholder = ''
    clearTimeout(this.inputFocusTimeout)
  
    const type = () => {
      if (i < this.input.dataset.textFocus.length) {
        this.input.placeholder += this.input.dataset.textFocus.charAt(i)
        i++
        this.inputFocusTimeout = setTimeout(type, 30)
      }
    }
    type()
  }

  onInputBlur () {
    clearTimeout(this.inputFocusTimeout)
    this.input.placeholder = this.input.dataset.textBlur
  }
}

customElements.define('predictive-search', PredictiveSearch)
